
import React, { useState } from "react";
import { Shop } from "@/components/dashboard/shops/types";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Pencil, Megaphone } from "lucide-react";

interface AnnouncementBarSectionProps {
  shop: Shop;
}

export const AnnouncementBarSection: React.FC<AnnouncementBarSectionProps> = ({ shop }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [announcementText, setAnnouncementText] = useState(shop.announcement_text || "");
  
  const handleSave = () => {
    // Here, you would implement the logic to save the changes
    // to the Supabase database
    
    // For now, we'll simply display a success toast
    toast.success("Modifications enregistrées avec succès", {
      description: "Le texte de la barre d'annonce a été mis à jour."
    });
    
    setIsEditing(false);
  };
  
  return (
    <div className="md:col-span-2">
      <Card className="shadow-md border-0 dark:border dark:border-gray-800">
        <CardHeader className="flex flex-row items-center justify-between pb-2">
          <CardTitle className="flex items-center gap-2">
            <Megaphone className="h-5 w-5" />
            Barre D'annonce
          </CardTitle>
          <Button 
            variant="outline" 
            size="sm" 
            onClick={() => setIsEditing(!isEditing)}
            className="flex items-center gap-1"
          >
            <Pencil className="h-4 w-4" />
            {isEditing ? "Annuler" : "Modifier"}
          </Button>
        </CardHeader>
        <CardContent>
          <div className="space-y-6">
            <div className="space-y-2">
              <Label htmlFor="announcement-text">Texte de la barre d'annonce</Label>
              {isEditing ? (
                <Input 
                  id="announcement-text" 
                  value={announcementText} 
                  onChange={(e) => setAnnouncementText(e.target.value)} 
                  placeholder="Texte à afficher dans la barre d'annonce"
                />
              ) : (
                <div className="text-gray-600 dark:text-gray-400 p-3 bg-gray-100 dark:bg-gray-800 rounded-md">
                  {announcementText || "Aucun texte d'annonce défini"}
                </div>
              )}
              
              {isEditing && (
                <p className="text-sm text-gray-500 mt-2">
                  Ce texte sera affiché dans une barre d'annonce en haut de votre boutique.
                </p>
              )}
            </div>
            
            {isEditing && (
              <div className="flex justify-end pt-4">
                <Button onClick={handleSave}>Enregistrer les modifications</Button>
              </div>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
